import {
  Container, Select, TextField, Typography,
  IconButton, ListItemText, Button, Badge
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';

export const FielderTextInputField = styled(TextField)({
	'& .MuiOutlinedInput-root': { borderRadius: '12px', },
});
export const FielderTextInputFieldLogin = styled(TextField)({
	'& .MuiOutlinedInput-root': { borderRadius: '12px', height: '63px', },
});
export const FielderSelectField = styled(Select)(() => ({
	borderRadius: '12px !important',
}));
export const SnackBarIconButton = styled(IconButton)({
	marginRight: '0px',
});
export const SnackBarTypoTitle = styled(Typography)({
	fontSize: '14px', fontWeight: 'bold', wordWrap: 'break-word',
});
export const SnackBarTypoDescription = styled(Typography)({
	fontSize: '13px', wordWrap: 'break-word',
});
export const SnackBarGridContainer = styled(Grid)({
	display: 'flex', maxWidth: '400px', minWidth: '80px', borderRadius: '8px'
});
export const SnackBarListItem = styled(ListItemText)({
	fontFamily: 'Lato', marginTop: '0px', marginLeft: '8px', marginRight: '1px',
});
export const StyleFielderRootContainerXXL =
  styled(Container)(({ theme }) => ({
	"&.MuiContainer-root": { maxWidth: '100%', padding: theme.spacing(3), paddingBottom: theme.spacing(7) }
}));
export const StyleFielderDefaultContainerXXL =
  styled(Container)(({ theme }) => ({
	"&.MuiContainer-root": { maxWidth: '100%', padding: theme.spacing(3), }
}));
export const StyleFielderDefaultContainerXL =
  styled(Container)(({ theme }) => ({
	"&.MuiContainer-root": { maxWidth: theme.breakpoints.values.xl, padding: theme.spacing(3), }
}));
export const StyleFielderDefaultContainerLG =
  styled(Container)(({ theme }) => ({
    "&.MuiContainer-root": { maxWidth: theme.breakpoints.values.lg, padding: theme.spacing(3), }
  }));
export const StyleFielderTitleTypography = styled(Typography)({
  fontFamily: 'Lato, sans-serif',
  mr: 2,
  display: { xs: 'none', md: 'flex' },
  fontWeight: 700,
  letterSpacing: '.3rem',
  color: 'inherit',
  textDecoration: 'none',
});
export const StyleFielderButton = styled(Button)(({ theme }) => ({
  fontFamily: 'Lato, sans-serif',
  textTransform: 'none',
  background: '#f5e6ed',
  color: '#dc5c87',
  borderRadius: '6px',
  '&:hover': {
    background: '#dc5c87',
    border: 'dc5c87',
    color: '#f5e6ed',
  },
}));
export const StyleFielderButtonOutlined = styled(Button)({
  textTransform: 'none',
  color: '#dc5c87',
  border: '1px solid #dc5c87',
  '&:hover': {
    backgroundColor: '#dc5c87',
    color: '#fff',
    border: '1px solid #dc5c87',
  },
});
export const StyleFielderButtonVariant = styled(Button)(
  ({ normal, hover }) => ({
    margin: 3,
    backgroundColor: normal,
    color: 'white',
    '&:hover': {
      backgroundColor: hover,
    },
  })
);
export const StyleFielderInfo = styled(Typography)({
  fontFamily: 'Lato, sans-serif',
  color: '#dc5c87',
});
export const StyledBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': { backgroundColor: '#dc5c87', color: 'white' },
}));
export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
